import { machineTypeSchema } from "@packsize/schemas/machines";

export const ZEBRA_MACHINES_QUERY_KEY = ["machines", { machineType: machineTypeSchema.enum.ZebraPrinter }] as const;
